/* =========================================================================
   Book Decoy — minimal site js
   Mobile menu toggle + FAQ accordion + PDP thumbs. Calm by design.
   ========================================================================= */
(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---- mobile menu ----------------------------------------------------
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]'))  $('[data-menu]')?.classList.add('is-open');
    if (e.target.closest('[data-menu-close]')) $('[data-menu]')?.classList.remove('is-open');
    if (e.target.closest('[data-menu] a'))     $('[data-menu]')?.classList.remove('is-open');
  });

  // ---- accordion ------------------------------------------------------
  document.addEventListener('click', (e) => {
    const head = e.target.closest('.acc__head');
    if (!head) return;
    head.closest('.acc__item')?.classList.toggle('is-open');
  });

  // ---- pdp thumb swap -------------------------------------------------
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.pdp-thumb');
    if (!t) return;
    const src = t.dataset.src;
    const main = $('[data-pdp-main]');
    if (main && src) main.src = src;
    $$('.pdp-thumb').forEach(el => el.classList.toggle('is-active', el === t));
  });

  // ---- nav scroll state -----------------------------------------------
  const nav = $('.bd-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- reduced-motion: pause looping videos to their poster ----------
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('video[data-bd-loop]').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    });
  }

  // ---- scroll reveal --------------------------------------------------
  if ('IntersectionObserver' in window) {
    const elements = $$('[data-reveal],[data-reveal-stagger]');
    if (elements.length) {
      document.body.classList.add('has-reveal');

      const reveal = (el) => el.classList.add('is-in');
      const visibleNow = (el) => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        return rect.top < vh * 0.95 && rect.bottom > 0;
      };

      elements.forEach((el) => {
        if (visibleNow(el)) reveal(el);
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      elements.forEach((el) => {
        if (!el.classList.contains('is-in')) observer.observe(el);
      });

      window.setTimeout(() => elements.forEach(reveal), 4000);
    }
  }
})();
